<template>
  <div class="good_detail" v-loading="spuLoading" :element-loading-text="$t('product.loading')">
    <div v-if="spuInfo && spuInfo.spuId">
      <!-- 类别显示 -->
      <div class="good_category">
        <div class="good_category_content home_page">
          <div>
            <el-breadcrumb separator="/" v-if="spuInfo" style="line-height: 48px">
              <!-- :to="{ path: '/personalCenter/basicInfo' }" -->
              <el-breadcrumb-item v-for="item in spuInfo.categoryChain" :key="item.id" :to="{
                name: `goodCategoryList`,
                query: {
                  foregroundCategoryId: item.id,
                },
              }">{{ item.name }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="cusService">
            <a @click="$consultJump($store.state.user)" class="consult">
              <img src="~@/assets/img/cusService.png" alt="" class="img_cusService" />
              联系客服
            </a>
          </div>
        </div>
      </div>
      <div class="detail_content home_page">
        <!-- 商品spu或sku信息显示 -->
        <div class="good_spku_info" style="margin-top: 0; padding: 0 0 20px 0">
          <div class="good_info_imgs flex-shrink">
            <div style="width: 448px; height: 448px; line-height: 448px">
              <goodImg class="goodImg" v-if="
                currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length &&
                currentSkuInfo.fileUrlList[mainGraphIndex]
              " :img="currentSkuInfo &&
                  currentSkuInfo.fileUrlList &&
                  currentSkuInfo.fileUrlList.length &&
                  currentSkuInfo.fileUrlList[mainGraphIndex]
                  "></goodImg>
              <img v-else src="@/assets/img/bitmap.png" alt="" width="448px" />
            </div>
            <!-- 图片轮播图 -->
            <div class="img-carousel" v-show="currentSkuInfo &&
              currentSkuInfo.fileUrlList &&
              currentSkuInfo.fileUrlList.length
              ">
              <el-carousel indicator-position="none" height="80px" v-if="currentSkuInfo && currentSkuInfo.fileUrlList">
                <el-carousel-item v-for="(i, ind) in Math.ceil(
                  currentSkuInfo.fileUrlList.length / 5
                )" :key="ind">
                  <div class="imgs-row">
                    <img :src="item" alt="商品主图" width="80px" height="80px" v-for="(item, index) in currentSkuInfo.fileUrlList.slice(
                      ind * 5,
                      ind * 5 + 5
                    )" :key="index" @click="changeShowImg(ind * 5 + index)" class="img_left"
                      :class="{ active: ind * 5 + index === mainGraphIndex }" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <!-- 功能区 收藏 -->
            <div class="good_sku_opt" :class="{ collected: collection }" v-show="currentActiveStatusSeckill < 2">
              <span @click="collectionHandle" class="cursor-pointer">
                <img src="@/assets/img/detailCollect.png" alt="" width="16px" />
                <span>{{ collection ? "已收藏" : "收藏" }}</span>
              </span>
            </div>
          </div>
          <div class="good_info_content flex-grow">
            <div class="good_spku_info" style="margin-top: 8px">
              <div class="flex-grow">
                <!-- sku 标题-->
                <div class="good_title line-break">
                  <!-- {{ currentSkuInfo.title }} -->
                  {{ goodsTitle }}
                </div>
                <!-- <div class="good_dec line-break">
                  {{ spuInfo.subtitle }}
                </div> -->
                <!-- 拼团活动 -->
                <div class="good-flex group-buying" v-if="currentActive && currentActive.promotionType === 3">
                  <div>
                    <img src="@/assets/img/good/clock.png" alt="" width="30px" height="30px" />
                    <span>拼团特卖</span>
                  </div>
                  <div>APP购买更优惠</div>
                </div>
                <!-- 价格 -->
                <div class="good-flex good-original-price" v-show="currentActiveStatusSeckill < 1">
                  <!-- tagPrice 原价 sellingPrice售价 tagPrice-->
                  <div class="flex-grow original-price">
                    <template v-if="custspId">
                      <template v-if="currentSkuInfo.discountRate">
                        <!-- 有折扣率 展示折扣价 -->
                        <div>
                          <div>
                            <span>折后价：</span>
                            <GoodPrice2 
                            :price="currentSkuInfo.sellingPrice || 0"
                            :losePrice="currentSkuInfo.originPrice || 0"
                            :discountRate="currentSkuInfo.discountRate || 0"
                            :unit="currentSkuInfo.sellingUnit||''"
                            ></GoodPrice2>
                          </div>
                          <div v-if="currentSkuInfo.originPrice">
                            <span>原价：</span><span class="cross-price" style="margin-left: 10px">
                              {{ $t("common.currency")
                              }}{{
                                currentSkuInfo.originPrice | formatePrice
                              }}
                            <span v-if="currentSkuInfo.sellingUnit" style="color: #333">/{{ currentSkuInfo.sellingUnit  }}</span>
                            </span>
                          </div>
                        </div>
                      </template>
                      <template v-else >
                        <good-price :price="currentSkuInfo.sellingPrice"></good-price>
                        <span v-if="currentSkuInfo.sellingUnit" style="color: #333">/{{ currentSkuInfo.sellingUnit  }}</span>
                      </template>
                     
                    </template>
                    <template v-else-if="
                      (currentSkuInfo &&
                        currentSkuInfo.isSellingPriceExpire) ||
                      commodityType >= 3
                    ">
                      {{ $t("home.rfq") }}
                    </template>
                    <template v-else-if="currentSkuInfo.originSellingPrice">
                      <div>
                        <div>
                          <span>折后价：</span><good-price :price="showPrice"></good-price>
                          <span v-if="currentSkuInfo.sellingUnit" style="color: #333">/{{ currentSkuInfo.sellingUnit  }}</span>
                          <span v-if="currentSkuInfo.discountRate" style="margin-left: 10px; color: #f63721">{{
                            Number(
                              (currentSkuInfo.discountRate * 10).toFixed(2)
                            )
                          }}折</span>
                      
                        </div>
                        <div v-if="currentSkuInfo.originSellingPrice">
                          <span>原价：</span><span class="cross-price" style="margin-left: 10px">
                            {{ $t("common.currency")
                            }}{{
                              currentSkuInfo.originSellingPrice | formatePrice
                            }}
                            <span v-if="currentSkuInfo.sellingUnit" style="color: #333">/{{ currentSkuInfo.sellingUnit  }}</span>
                          </span>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <good-price :price="showPrice"></good-price>
                      <span class="cross-price" v-show="!currentSkuInfo.tagPrice &&
                        currentActive &&
                        (currentActive.promotionType === 1 ||
                          currentActive.promotionType === 2)
                        ">{{ $t("product.marketPrice") }}：{{
                          $t("common.currency")
                        }}{{ currentSkuInfo.sellingPrice | formatePrice }}</span>
                      <span class="cross-price" v-if="currentSkuInfo.tagPrice">
                        <!-- 原价： -->{{ $t("common.currency")
                        }}{{ currentSkuInfo.tagPrice | formatePrice }}
                      </span>
                      <span v-if="currentSkuInfo.sellingUnit" style="color: #333">/{{ currentSkuInfo.sellingUnit  }}</span>
                    </template>
                  </div>

                  <div style="margin-right: 20px" v-if="spuInfo.tagNameList && spuInfo.tagNameList.length">
                    <el-tag v-for="(item, index) in spuInfo.tagNameList" :key="index" size="small"
                      style="margin-left: 3px" type="danger" effect="dark">
                      {{ item }}
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
            <!-- 秒杀活动未开始价格显示 -->
            <div class="good-flex good-original-price" v-show="currentActiveStatusSeckill === 1">
              <label class="lable flex-shrink">{{ $t("product.price") }}：</label>
              <!-- tagPrice 原价 sellingPrice售价 tagPrice-->
              <div class="flex-grow original-price">
                <good-price :price="currentSkuInfo.sellingPrice"></good-price>
                <span class="activity-not-start" v-show="showPrice">{{ $t("product.priceSpike2") }}：{{
                  $t("common.currency")
                  }}{{ showPrice | formatePrice }}</span>
                  <span v-if="currentSkuInfo.sellingUnit" style="color: #333">/{{ currentSkuInfo.sellingUnit  }}</span>
              </div>
              <!-- v-show="!currentActive || (currentActive.promotionType !== 1 && currentActive.promotionType !== 3)" -->
            </div>
            <!-- 秒杀活动开始 -->
            <div class="good-flex good-original-price" v-show="currentActiveStatusSeckill > 1">
              <label class="lable flex-shrink">{{
                $t("product.priceSpike")
                }}</label>
              <!-- tagPrice 原价 sellingPrice售价 tagPrice-->
              <div class="flex-grow original-price">
                <good-price :price="showPrice"></good-price>
                <span class="cross-price" v-show="currentSkuInfo.sellingPrice">
                  <!-- 原价： -->{{ $t("common.currency")
                  }}{{ currentSkuInfo.sellingPrice | formatePrice }}
                </span>
                <span v-if="currentSkuInfo.sellingUnit" style="color: #333">/{{ currentSkuInfo.sellingUnit  }}</span>
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">{{
                $t("product.shippingCost")
                }}</label>
              <div class="flex-grow">
                {{ spuInfo.userLabel || "" }} <el-button type="text" @click="showFreightPolicy">运费政策</el-button>
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">{{ $t("common.model") }}</label>
              <div class="flex-grow good-models">
                <div class="good-model" v-for="item in skuInfoList" :key="item.skuId" :class="{
                  'good-model-choosed': item.skuId == currentSkuInfo.skuId,
                }" @click="changeCurrentSku(item)">
                  {{ getModel(item) }}
                </div>
                <!-- <div class="good-model good-model-choosed">111</div> -->
              </div>
            </div>
            <div class="good-flex" v-show="commodityType < 3 || commodityType === 4">
              <label class="lable flex-shrink">{{
                $t("common.quantity")
                }}</label>
              <div class="flex-grow">
                <el-tooltip
                  :disabled="true"
                  placement="top"
                  :content="`最小起订量${currentSkuInfo.moq || 1}, 最小包装量${
                    currentSkuInfo.sellingUnitStepSize || 1
                  }`"
                >
                  <span>
                    <el-input-number size="mini" :disabled="loading" v-model="count" :step="1" :min="1" :max="999999999"
                      :precision="0"></el-input-number></span></el-tooltip>
                <span style="color: #999">
                  （{{
                    `最小起订量：${currentSkuInfo.moq || 1}， 最小包装量：${
                      currentSkuInfo.sellingUnitStepSize || 1
                    }`
                  }}）
                </span>
              </div>
            </div>
            <div class="good-flex" v-show="currentSkuInfo.sellingUnit">
              <label class="lable flex-shrink">{{ $t("common.brand") }}</label>
              <div class="flex-grow">
                {{ spuInfo.brandLogoInfo?spuInfo.brandLogoInfo.name :'无'}}
              </div>
            </div>
            <div class="good-flex" v-show="currentSkuInfo.commodityDeliveryCycle">
              <label class="lable flex-shrink">{{
                $t("product.leadTime")
                }}</label>
              <div class="flex-grow">
                {{ currentSkuInfo.commodityDeliveryCycle }} 个工作日
              </div>
            </div>
            <div class="good-flex" v-show="currentSkuInfo.skuCode">
              <label class="lable flex-shrink">{{ $t("product.sku") }}</label>
              <div class="flex-grow">
                {{ goodsCode }}
              </div>
            </div>
            <div class="good-flex" v-show="spuInfo">
              <label class="lable flex-shrink">{{
                $t("product.productNo")
                }}</label>
              <div class="flex-grow">
                {{ spuInfo.supplyCommodityCode }}
              </div>
            </div>
            <div class="good-flex" v-show="spuInfo">
              <label class="lable flex-shrink">支付方式</label>
              <div class="flex-grow" style="display: inline-flex; line-height: 18px">
                <span class="payway">
                  <img src="@/assets/img/good/transfer.png" />线下转账
                </span>
                <span class="payway">
                  <img src="@/assets/img/good/alipay.png" />支付宝
                </span>
                <span class="payway">
                  <img src="@/assets/img/good/weixin.png" />微信
                </span>
              </div>
            </div>
            <div class="good-flex" v-show="spuInfo.serviceGuaranteesTypeList &&
              spuInfo.serviceGuaranteesTypeList.length
              ">
              <label class="lable flex-shrink">{{
                $t("product.service")
                }}</label>
              <div class="flex-grow good-services">
                <div class="service" v-for="item in spuInfo.serviceGuaranteesTypeList" :key="item">
                  <i class="el-icon-circle-check icon-color"></i>
                  {{ item }}
                </div>
              </div>
            </div>
            <!-- 活动相关 -->
            <div class="good-flex promotion" v-if="currentActive && currentActive.promotionType === 1">
              <div class="promotion-title">
                <img src="@/assets/img/good/clock.png" alt="" width="16px" height="16px" class="promotion-clock-img" />
                限时秒杀
                <span class="promotion-count">
                  {{
                    currentActive.promotionInfo.promoitionStatus === 1
                      ? "限售"
                      : "仅剩"
                  }}
                  {{ currentActive.promotionInfo.skuStock }}件
                </span>
              </div>
              <div class="promotion-time">
                <div class="promotion-content-arrow"></div>
                <div class="promotion-content">
                  <count-down @start_callback="activeStartHandle(1)" @end_callback="activeEndHandle(1)"
                    :currentTime="new Date().getTime()" :startTime="new Date().getTime() +
                      (Number(
                        currentActive.promotionInfo.promotionStartTimeLong
                      ) || 0)
                      " :endTime="new Date().getTime() +
                      (Number(currentActive.promotionInfo.expiredTime) || 0)
                      " tipText="距离开始" tipTextEnd="距离结束" endText="活动已结束" dayTxt="天" secondsTxt=""></count-down>
                </div>
              </div>
              <!-- <label class="lable flex-shrink">数量</label>
              <div class="flex-grow">
                <el-input-number size="small" v-model="count" :min="1" :max="currentSkuInfo.inventoryQuantity || 999999999" :precision="0"></el-input-number>
              </div> -->
            </div>
            <div class="bottom">
              <!-- 标品 -->
              <div v-show="commodityType < 2">
                <!-- 无活动/拼团 -->
                <div class="good-opt" v-show="(currentActive &&
                    (currentActive.promotionType === 0 ||
                      currentActive.promotionType === 3)) ||
                  !currentActive
                  ">
                  <!-- <el-button class="buy-imm but_ban"
                             v-if="currentSkuInfo.inventoryQuantity <= 0"
                             :loading="loading">已售光</el-button> -->
                  <template v-if="currentSkuInfo && currentSkuInfo.isSellingPriceExpire">
                    <el-button class="buy-inquiry" @click="goInquiry()" :loading="loading">{{ $t("product.quotation")
                      }}</el-button>
                    <el-button class="buy-inquiry" @click="addCart('2')" :loading="loading">{{
                      $t("product.addQuotation") }}</el-button>
                    <!-- <el-button
                      class="buy-inquiry"
                      :loading="loading"
                    >
                      Coming Soon
                    </el-button> -->
                  </template>
                  <template v-else>
                    <el-button class="buy-imm" @click="buySku" :loading="loading">{{ $t("product.buyNow") }}</el-button>
                    <el-button class="add-cart" @click="addCart('1')" :loading="loading">{{ $t("product.addCart")
                      }}</el-button>
                  </template>
                </div>
                <!-- 秒杀 -->
                <!-- currentActiveStatusSeckill>0 -->
                <div class="good-opt" v-show="currentActive && currentActive.promotionType === 1">
                  <el-button class="buy-imm activity-but" v-if="currentActiveStatusSeckill === 3">已结束</el-button>
                  <el-button class="buy-imm activity-but but_ban" v-else-if="stockCount <= 0">已抢光</el-button>
                  <el-button class="buy-imm activity-but" v-else @click="buySku" :loading="loading">{{
                    $t("product.buyNow")
                    }}</el-button>
                  <el-button v-if="stockCount <= 0" class="add-cart activity-but but_ban" :loading="loading">{{
                    $t("product.addCart") }}</el-button>
                  <el-button v-else class="add-cart activity-but" :loading="loading" @click="addCart('1')">{{
                    $t("product.addCart")
                    }}</el-button>
                </div>
                <!-- 专题 -->
                <div class="good-opt" v-show="currentActive && currentActive.promotionType === 2">
                  <el-button class="buy-imm activity-but but_ban"
                    v-if="currentSkuInfo.inventoryQuantity <= 0">已售光</el-button>
                  <el-button class="buy-imm activity-but" @click="buySku" :loading="loading">{{ $t("product.buyNow")
                    }}</el-button>
                  <!-- <el-button v-if="stockCount<=0"
                            class="add-cart activity-but but_ban">{{$t('product.addCart')}}</el-button> -->
                  <el-button class="add-cart activity-but" :loading="loading" @click="addCart('1')">{{
                    $t("product.addCart")
                    }}</el-button>
                </div>
              </div>
              <!-- 非标品 去询价-->
              <div v-show="commodityType > 2">
                <div class="good-opt">
                  <!-- <el-button
                    class="buy-inquiry"
                    :loading="loading"
                  >
                    Coming Soon
                  </el-button> -->
                  <el-button class="buy-inquiry" @click="goInquiry()" :loading="loading">{{
                    commodityType > 3
                      ? $t("product.quotation")
                      : $t("product.quotationNow")
                  }}</el-button>
                  <el-button class="buy-inquiry" @click="addCart('2')" v-show="commodityType > 3" :loading="loading">{{
                    $t("product.addQuotation") }}</el-button>
                  <el-button class="buy-inquiry" @click="goInquiryTry()" v-show="commodityType === 3"
                    :loading="loading">{{
                      $t("product.trial") }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 商品组相关 -->
        <SpuGroup :skuId="skuId || currentSkuInfo.skuId" v-if="skuId || currentSkuInfo.skuId" />
        <!-- 搭配型号 -->
        <div class="match-model" v-show="correlativeSpuInfoList.length">
          <el-tabs type="border-card" :class="{ 'promotion-tab': currentActiveStatusSeckill > 0 }" style="width: 100%">
            <el-tab-pane>
              <span slot="label">搭配型号</span>
              <el-carousel :interval="5000" arrow="always" height="250px" v-if="correlativeSpuInfoList.length">
                <el-carousel-item v-for="(i, idx) in Math.ceil(
                  correlativeSpuInfoList.length / 5
                )" :key="idx">
                  <!-- <h3>{{ item }}</h3> -->
                  <div class="collocation">
                    <div class="collocation-good" v-for="item in correlativeSpuInfoList.slice(
                      idx * 5,
                      idx * 5 + 5
                    )" :key="item.correlativeSpuId" @click="choosedSpuId(item)">
                      <img :src="item.fileUrl" alt="" width="178px" height="178px" />
                      <div class="collocation-good-name ellipsis">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 商品详情相关信息 -->
        <div class="good_spku_info">
          <el-tabs type="border-card" :class="{ 'promotion-tab': currentActiveStatusSeckill > 0 }" style="width: 100%">
            <el-tab-pane>
              <span slot="label">{{ $t("product.detail") }}</span>
              <div class="line-break good_spu_detail">
                <div v-for="detailInfo in allDetailInfo" :key="detailInfo.type" class="detail-item">
                  <template v-if="detailInfo.name && detailInfo.paraText">
                    <div class="good-detail-title">
                      <div class="name">{{ detailInfo.name }}</div>
                    </div>
                    <div class="content" v-html="detailInfo.paraText"></div>
                  </template>
                </div>
              </div>
              <!-- <div v-html="spuDetailInfo"
                   class="line-break good_spu_detail"></div> -->
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label">{{ $t("product.relatedParameters") }}</span>
              <div v-for="optionItem in attributeGroupList" :key="optionItem.attributeGroupId" class="groupParams">
                <div class="model-params-name">
                  {{ optionItem.name }}
                </div>
                <div v-for="attItem in optionItem.attributeItemList" :key="attItem.attributeItemId" class="attList">
                  <div class="att-name">{{ attItem.name }}</div>
                  <div class="att-value">
                    {{ attItem.attributeValueList | formatAtt }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label">{{ $t("product.manualBook") }}</span>
              <div v-if="currentSkuInfo && currentSkuInfo.manualFile"
                @click="viewAttachment(currentSkuInfo.manualFile.fileUrl)" class="attachment">
                {{ currentSkuInfo.manualFile.fileName || currentSkuInfo.title }}
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="good_spku_info">
          <div style="
              width: 100%;
              height: 46px;
              background: #f5f5f5;
              border: 1px solid #dedede;
              font-size: 18px;
              color: #333;
              line-height: 46px;
              padding-left: 20px;
            ">
            {{ $t("product.noteTitle") }}
          </div>
        </div>
        <div class="good_spku_info" style="margin-top: 0">
          <div style="
              width: 100%;
              border: 1px solid #dedede;
              font-size: 14px;
              color: #333;
              padding: 20px;
              border-top: none;
            ">
            <div style="color: #666; margin-bottom: 8px">
              <span style="font-weight: bold">{{ $t("product.title1") }}：</span>{{ $t("product.content1") }}
            </div>
            <div style="color: #666; margin-bottom: 8px">
              <span style="font-weight: bold">{{ $t("product.title2") }}：</span>{{ $t("product.content2") }}
            </div>
            <div style="color: #666; margin-bottom: 8px">
              <span style="font-weight: bold">{{ $t("product.title3") }}：</span>{{ $t("product.content3") }}
            </div>
            <div style="color: #666">
              <span style="font-weight: bold">{{ $t("product.title4") }}：</span>{{ $t("product.content4") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_page" v-else>
      <div class="no_show_message">
        <img src="@/assets/img/good/noGood.png" :alt="$t('product.loading')" />
        <!-- <div>努力加载中</div> -->
      </div>
    </div>
    <company-add ref="companyAdd" v-if="addCompanyVisible" :jumpRoute="false"></company-add>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
import CountDown from '@/components/count-down'
import GoodPrice from '@/components/good-price'
import GoodPrice2 from '@/components/good-price/goodPrice.vue'
import goodImg from '@/components/img'
import { openOther } from '@/utils'
import CompanyAdd from '@/views/modules/personalCenter/organization/company-add'
import SpuGroup from '@/views/modules/good/components/spuGroup.vue'
export default {
  data () {
    return {
      loading: false,
      spuLoading: false,
      spuInfo: null,
      correlativeSpuInfoList: [], // 搭配型号,
      attributeGroupList: [], // 参数项
      skuInfoList: [], // sku列表
      spuDetailInfo: '', // 商品详情
      count: 1,
      collection: false, // 收藏
      mainGraphIndex: 0, // 主图索引
      currentActive: null,
      addCompanyVisible: false, // 企业账号 dialog
      allDetailInfo: [],
      changeAble: false
    }
  },
  components: {
    CountDown,
    GoodPrice,
    goodImg,
    SpuGroup,
    CompanyAdd,
    GoodPrice2
  },
  computed: {
    goodsTitle(){
      if(this.custspId&& this.currentSkuInfo.obj){
        return this.currentSkuInfo.obj.oldGoodsName || this.currentSkuInfo.title ||''
      }else{
        return this.currentSkuInfo.title ||''
      }
    },
    goodsCode(){
      if(this.custspId&& this.currentSkuInfo.obj){
        return this.currentSkuInfo.obj.oldGoodsCode || this.currentSkuInfo.skuCode ||''
      }else{
        return this.currentSkuInfo.skuCode ||''
      }
    },
    groupId () {
      return this.$route.query.groupId
    },
    spuId () {
      return this.$route.query.spuId
    },
    skuId () {
      return this.$route.query.skuId
    },
    custspId () {
      return this.$route.query.custspId
    },
    currentSkuInfo () {
      let currentSku = {
        fileUrlList: []
      }
      let fileUrlList = this.spuInfo
        ? JSON.parse(JSON.stringify(this.spuInfo.fileUrlList)) || []
        : []
      if (
        this.skuId &&
        this.skuInfoList &&
        this.skuInfoList.length > 0 &&
        this.skuInfoList.findIndex((item) => {
          return item.skuId === this.skuId
        }) > -1
      ) {
        currentSku = this.skuInfoList.find((item) => {
          return item.skuId + '' === this.skuId + ''
        })
        if (currentSku) {
          if (currentSku.fileUrl) {
            fileUrlList.unshift(currentSku.fileUrl)
          }
          currentSku.fileUrlList = fileUrlList
        } else {
          currentSku = {
            fileUrlList: fileUrlList
          }
        }
      } else if (this.skuInfoList && this.skuInfoList.length > 0) {
        let minPrice = Math.min.apply(
          Math,
          this.skuInfoList.map((o) => {
            return o.sellingPrice
          })
        )
        currentSku = this.skuInfoList.find((item) => {
          return item.sellingPrice === minPrice
        })
        if (!currentSku) {
          currentSku = this.skuInfoList[0]
        }
        // if (currentSku.fileUrl) {
        //   fileUrlList.unshift(currentSku.fileUrl)
        // }
        currentSku.fileUrlList = fileUrlList
      } else {
        currentSku = {
          title: this.spuInfo ? this.spuInfo.name : '',
          tagPrice: 0,
          fileUrlList: fileUrlList,
        }
      }
      return currentSku
    },
    // 当前秒杀活动状态
    currentActiveStatusSeckill () {
      // 0 不是秒杀  1未开始，2一开始，3，已结束
      let status = 0
      if (this.currentActive && this.currentActive.promotionType === 1) {
        status = this.currentActive.promotionInfo.promoitionStatus
      }
      return status
    },
    // 秒杀/专题活动库存数量
    stockCount () {
      let stockCount = 0
      if (
        this.currentActive &&
        (this.currentActive.promotionType === 1 ||
          this.currentActive.promotionType === 2)
      ) {
        // 总量
        let availableInventory =
          this.currentActive.promotionInfo.availableInventory || 0
        // 销售数量
        let saleInventory = this.currentActive.promotionInfo.saleInventory || 0
        stockCount = availableInventory - saleInventory
      }
      return stockCount > 0 ? stockCount : 0
    },
    showPrice () {
      let price = this.currentSkuInfo ? this.currentSkuInfo.sellingPrice : 0
      if (this.currentActive) {
        if (this.currentActive.promotionType === 1) {
          // 秒杀
          if (this.currentActive.promotionInfo) {
            price = this.currentActive.promotionInfo.promotionSalePrice
          }
        } else if (this.currentActive.promotionType === 2) {
          // 专题活动
          if (this.currentActive.promotionInfo) {
            price = this.currentActive.promotionInfo.promotionSalePrice
          }
          // } else if (this.currentActive.promotionType === 3) {
          //   // 拼团
          //   if (this.currentActive.currentSkuInfo) {
          //     // price = this.currentActive.currentSkuInfo.promotionSalePrice
          //   }
        }
      }
      if(this.currentSkuInfo.custspId){
        price = this.currentSkuInfo.discountPrice
      }
      return price
    },
    /**
     * 商品spu的类型
     * 1实物-标品 默认，
     * 2虚拟-标品
     * 3虚拟-非标询价品，可去询价 不可以加入询价篮
     * 4实物-非标询价品，可去询价
     */
    commodityType () {
      let type = 1
      if (this.spuInfo) {
        if (this.spuInfo.commodityType === '虚拟-标品') {
          type = 2
        } else if (this.spuInfo.commodityType === '虚拟-非标询价品') {
          type = 3
        } else if (this.spuInfo.commodityType === '实物-非标询价品') {
          type = 4
        }
      }
      return type
    }
  },
  watch: {
    spuId: {
      immediate: true,
      handler: 'getGoodInfo'
    },
    skuId (val) {
      this.count = 1
      this.getSkuCollect()
    }
  },
  filters: {
    formatAtt (att) {
      return att
        .map((item) => {
          return item.name
        })
        .join('、')
    }
  },
  created () {
    // 暂时性解决 app banner跳转商详显示问题
    // document.body.clientWidth
    if (this.$route.query.token) {
      Cookies.set('access_token_shop', this.$route.query.token)
    }
  },
  mounted () { },
  methods: {
    getModel(){
      if(this.custspId && this.currentSkuInfo.obj){
        return this.currentSkuInfo.obj.oldModel || this.currentSkuInfo.model ||''
      }else{
        return this.currentSkuInfo.model ||''
      }
    },
    showFreightPolicy () {
      // this.$router.push({
      //   name: 'freightPolicy'
      // })
      window.open(window.location.origin + '/freightPolicy')
    },
    // 保存浏览记录
    saveBrowseHistory () {
      let token = getAccessToken()
      if (!token || !this.currentSkuInfo.skuId) {
        return
      }
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        this.$http.post(`/front/oms/crop-site/browse-history/add`,{
          custspId:this.currentSkuInfo.custspId,
          skuId: this.currentSkuInfo.skuId
        })
      }else{
        this.$http.post(`/front/oms/shopping/browse-history/save`, {
          // 前端写死 1002 = 商城
          'appId': '1002',
          'skuId': this.currentSkuInfo.skuId
        })
      }
    },
    // 获取商品详情信息
    getGoodInfo () {
      if (!this.spuId) {
        return false
      }
      this.spuInfo = null
      this.correlativeSpuInfoList = []
      this.attributeGroupList = []
      this.skuInfoList = []
      this.spuDetailInfo = ''
      this.spuLoading = true
      if(this.custspId){
        this.$http
        .post(`/front/order/lclb/custsp/getCommoditySkuInfo`, {
          companyId: this.$store.state.user.defaultCompanyId,
          spuId: this.$route.query.spuId,
          skuId: this.$route.query.skuId,
          custspId: this.$route.query.custspId
        }) 
        .then(({data:res})=>{
          if(res.code === 0){
            this.getGoodsInfoHandle(res.data)
          }
        })
        .finally(() => {
          this.spuLoading = false
        })
        return
      }
      this.$request
        .get(`/front/cross/commodity-user/spu-detail/${this.spuId}`)
        .then(this.getGoodsInfoHandle)
        .finally(() => {
          this.spuLoading = false
        })
      
    
    },
    getGoodsInfoHandle(res) {
        console.log(res);
        
        this.spuInfo = res.spuInfo
        this.correlativeSpuInfoList = res.correlativeSpuInfoList
        this.attributeGroupList = res.attribute
          ? res.attribute.attributeGroupList || []
          : []
        this.skuInfoList = res.skuInfoList || []
        this.spuDetailInfo = res.spuDetailInfoForWeb || ''
        this.allDetailInfo = res.allDetailInfo || []
        this.getSkuCollect()
        this.saveBrowseHistory()
    },
    // 更改主图的索引
    changeShowImg (index) {
      this.mainGraphIndex = index
    },
    // 判断当前sku商品是否被收藏
    getSkuCollect () {
      this.collection = false
      if (!this.currentSkuInfo.skuId) {
        return false
      }
      this.getCurrentSkuActive()
      // 未登录
      if (!getAccessToken()) {
        return false
      }
      this.loading = true
      this.$request
        .post(
          `/front/commodity-user/app/collected/${this.currentSkuInfo.skuId}`
        )
        .then((res) => {
          this.collection = res
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false
        })
    },
    // 收藏或者取消收藏
    collectionHandle () {
      if (this.loading) {
        return false
      }
      if (!this.currentSkuInfo.skuId) {
        this.$message.warning('请选择型号')
        return false
      }
      // 未登录
      if (!getAccessToken()) {
        // this.$router.push({
        //   name: 'login'
        // })
        this.bus.$emit('showLoginDialog')
        return false
      }
      this.loading = true
      this.$http
        .post(
          `/front/commodity-user/app/${this.collection ? 'cancel-collect' : 'collect'
          }/${this.currentSkuInfo.skuId}`
        )
        .then(({ data: res }) => {
          this.$message.success(this.collection ? '取消收藏成功' : '收藏成功')
          this.collection = !this.collection
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取当前sku 的活动
    getCurrentSkuActive () {
      this.$request
        .get(
          `/front/consumer/order/groupActivity/activity/${this.currentSkuInfo.skuId}`
        )
        .then((res) => {
          this.currentActive = res
        })
        .catch(() => {
          this.currentActive = null
        })
    },
    // 更改当前选中的sku
    changeCurrentSku (item) {
      if (this.loading) {
        return false
      }
      this.mainGraphIndex = 0
      if (item.skuId + '' === this.skuId + '') {
        return false
      }
      this.$router.push({
        name: 'goodDetail',
        query: {
          groupId: this.groupId || undefined,
          spuId: this.spuId,
          skuId: item.skuId + '' === this.skuId + '' ? undefined : item.skuId
        }
      })
    },
    // 立即购买
    buySku () {
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning(this.$t('message.chooseModel'))
        return false
      }
      let { sellingUnitStepSize, title, moq } = this.currentSkuInfo
      !moq && (moq = 1)
      !sellingUnitStepSize && (sellingUnitStepSize = 1)
      if (this.count < +moq || this.count % sellingUnitStepSize !== 0) {
        this.$message.warning(
          `${title} 最小起订量为${
            moq || 1
          }，最小包装量为${sellingUnitStepSize}，请输入大于${
            moq || 1
          }且${sellingUnitStepSize}的倍数！`
        )
        return
      }
      // const sellingUnitStepSize = !!suss ? suss : 1;
      // if (this.count % (+sellingUnitStepSize || 1) !== 0) {
      //   this.$message.warning(
      //     `【${title}】最小包装量为${sellingUnitStepSize}，请输入${sellingUnitStepSize}的倍数！`
      //   )
      //   return false
      // }

      // 未登录 跳转登录页
      if (!getAccessToken()) {
        // this.$router.push({
        //   name: 'login'
        // })
        this.bus.$emit('showLoginDialog')
        return false
      }
      if (this.loading) {
        return false
      }
      // if (!this.$store.state.user.defaultCompanyId) {
      //   // 非企业用户先升级才可下单
      //   this.$confirm(this.$t('navbar.storeSpare1'), this.$t('prompt.title'), {
      //     dangerouslyUseHTMLString: true,
      //     confirmButtonText: this.$t('navbar.upgrade'),
      //     cancelButtonText: this.$t('cancel')
      //   }).then(() => {
      //     this.addCompanyVisible = true
      //     this.$nextTick(() => {
      //       this.$refs.companyAdd.init()
      //     })
      //   })
      //   return false
      // }
      this.loading = true
      // 校验该商品 及数量是否可以购买
      this.$http
        .post(`/front/consumer/shoppingcart/checkCommodityPromotion`, [
          {
            commodityId: this.currentSkuInfo.skuId,
            commodityNum: this.count
          }
        ])
        .then(({ data: res }) => {
          if (res.code === 0) {
            // 跳转创订单页面
            const t = new Date().getTime()
            const obj = {
              t,
              orderSource: '20',
              shoppingCartFormList: [{
                goodsSpuId: this.currentSkuInfo.spuId,
                goodsSkuId: this.currentSkuInfo.skuId,
                custspId: this.custspId,
                sellingPrice: this.currentSkuInfo.sellingPrice,
                goodsNum: this.count
              }]
            }
            sessionStorage.setItem('createOrder', JSON.stringify(obj))
            this.$router.push({
              name: 'createOrder',
              query: {
                t
              }
            })
          } else {
            this.$confirm(res.message, this.$t('prompt.title'), {
              confirmButtonText: this.$t('confirm'),
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            })
              .then(() => { })
              .catch(() => { })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 加入购物车
    addCart (shoppingType = '1') {
      // 购物车类型 ==1 是商品购物车，==2 是询价篮
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning(this.$t('message.chooseModel'))
        return false
      }
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        // this.$router.push({
        //   name: 'login'
        // })
        this.bus.$emit('showLoginDialog')
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: this.currentSkuInfo.custspId,
          skuId: this.currentSkuInfo.skuId,
          goodsNum: this.count
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success('购物车添加成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http
        .post(`/front/consumer/shoppingcart/addShoppingCart`, {
          goodsSpuId: this.spuId,
          goodsSkuId: this.currentSkuInfo.skuId,
          goodsNum: this.count,
          shoppingType: shoppingType
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success(
            `${this.$t('product.add')} ${shoppingType === '1'
              ? this.$t('product.cart')
              : this.$t('product.blanket')
            } ${this.$t('product.success')}`
          )
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 去询价
    goInquiry () {
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning(this.$t('message.chooseModel'))
        return false
      }
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        // this.$router.push({
        //   name: 'login'
        // })
        this.bus.$emit('showLoginDialog')
        return false
      }
      if (this.loading) {
        return false
      }
      // to do
      this.$router.push({
        name: 'inquiryCreate',
        query: {
          goodList:
            this.currentSkuInfo.spuId +
            ',' +
            this.currentSkuInfo.skuId +
            ',' +
            this.count
        }
      })
    },
    // 申请试用
    goInquiryTry () {
      this.$router.push({
        name: 'applyUsed'
      })
    },
    // 点击搭配型号 更改spu
    choosedSpuId (item) {
      if (item.correlativeSpuId + '' === this.spuId) {
        return false
      }
      openOther(`goodDetail?spuId=${item.correlativeSpuId}&skuId=`)
      // this.$router.push({
      //   name: 'goodDetail',
      //   query: {
      //     spuId: item.correlativeSpuId,
      //     skuId: ''
      //   }
      // })
    },
    // 查看附件
    viewAttachment (url) {
      if (url) {
        window.open(url)
      }
    },
    // 活动开始
    activeStartHandle () {
      this.currentActive.promotionInfo.promoitionStatus = 2
    },
    // 活动结束
    activeEndHandle () {
      this.currentActive.promotionInfo.promoitionStatus = 3
      // console.log('')
    },
    brandHandle (brandId) {
      if (!brandId) {
        return false
      }
      this.$router.push({
        name: 'goodBrandCategoryList',
        query: {
          foregroundCategoryId: '',
          brandIdList: brandId + '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    // 去咨询
    goconSultHandle () {
      this.$router.push({
        name: 'goodBrandCategoryList'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.good_detail {
  background: #fff;
  padding-bottom: 30px;

  .activity-but {
    color: #fff;
    background-color: #cb2a22;
  }

  /deep/ .promotion-tab {
    .is-top .is-active {
      color: #fff;
      background-color: #cb2a22;
    }
  }

  .good-flex {
    margin-top: 12px;
    line-height: 20px;
    // letter-spacing: 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #555555;

    .lable {
      width: 70px;
      margin-right: 20px;
      // padding-left: 20px;
      // text-align: justify;
      text-align-last: justify;
      position: relative;

      &::after {
        content: ":";
        position: absolute;
        right: -6px;
      }
    }
  }

  .good_category {
    background: #f2f2f2;

    .good_category_content {
      display: flex;
      justify-content: space-between;
      color: #262727;
      line-height: 48px;
      font-size: 16px;

      .cusService {
        cursor: pointer;

        .img_cusService {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .detail_content {
    padding-top: 20px;

    .good_spku_info {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .good_brand {
        width: 120px;
      }

      .good_info_imgs {
        width: 448px;

        .img-carousel {
          margin-top: 12px;

          // height: 60px;
          .imgs-row {
            width: 100%;
            height: 80px;

            // padding-left: 20px;
            // padding-right: 20px;
            .img_left {
              object-fit: contain;
              margin-left: 12px;
              cursor: pointer;

              &:first-child {
                margin-left: 0;
              }

              &.active {
                border: 1px solid #2a54d1;
                // box-shadow: inset 0px 0px 0px 1px #2a54d1;
                border-radius: 10px;
              }
            }
          }

          /deep/ .el-carousel__arrow {
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.3);

            &:hover {
              background-color: rgba(0, 0, 0, 0.5);
            }

            &--right,
            &--left {
              width: 22px;
              height: 32px;
            }

            &--left {
              left: 0;
            }

            &--right {
              right: 0;
            }

            i {
              transform: scaleY(1.5);
            }
          }
        }

        .goodImg {
          width: 100%;
          height: 100%;

          /deep/ .goodImg {
            width: 100%;
            height: 100%;
          }
        }

        .good_sku_opt {
          margin-top: 12px;
          font-size: 0;
          color: #fff;

          &.collected {
            >span {
              background: #ff4c2b;
            }
          }

          >span {
            background: rgba(42, 84, 209, 0.31);
            display: inline-block;
            padding: 4px 6px;
            border-radius: 8px;
            vertical-align: middle;

            span {
              margin-left: 3px;
              display: inline-block;
              vertical-align: middle;
              font-size: 14px;
            }
          }
        }
      }

      .good_info_content {
        margin-left: 50px;
        position: relative;
        padding-bottom: 0;

        .good_title {
          padding-right: 20px;
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
          margin-bottom: 14px;
        }

        .good_dec {
          margin-top: 10px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 400;
          color: #d92a2a;
          line-height: 22px;
        }

        .group-buying {
          justify-content: space-between;
          padding-left: 13px;
          padding-right: 13px;
          font-size: 18px;
          color: #ffffff;
          line-height: 36px;
          background: linear-gradient(130deg, #ff6793 10%, #ff0c0c 100%);
        }

        .good-original-price {
          margin-top: 0;

          // height: 70px;
          // background: #f5f5f5;
          .original-price {
            font-size: 14px;
            font-weight: bold;
            color: #e64c3a;

            // letter-spacing: 4px;
            /deep/ .price {
              color: #ff4c2b;
              display: inline-block;

              .price-int {
                font-size: 26px;
              }

              .price-point {
                font-size: 14px;
              }
            }

            .cross-price {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-decoration: line-through;
              text-align: left;
              color: #666666;
              line-height: 18px;
            }

            .activity-not-start {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              // color: #666666;
              line-height: 18px;
            }
          }
        }

        .good-models {
          margin: -5px 0;

          .good-model {
            margin: 5px 10px 5px 0;
            display: inline-block;
            border: 1px solid #dedede;
            padding: 5px 15px;
            color: #333333;
            font-weight: 400;
            font-size: 14px;
            cursor: pointer;
          }

          .good-model-choosed {
            border-color: #2e88ff;
          }
        }

        .payway {
          padding-right: 24px;
          display: inline-flex;

          img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
          }

          &:last-child {
            padding-right: 0;
          }
        }

        .bottom {
          // position: absolute;
          // bottom: 0;
          margin-top: 28px;

          .good-opt {
            // margin-left: 20px;
            color: #fff;

            .buy-imm {
              min-width: 150px;
              border: none;
              background: #ff4c2b;
              color: #fff;
            }

            .buy-inquiry {
              min-width: 150px;
              border: none;
              background: #2a54d1;
              color: #fff;
            }

            // 禁用
            .but_ban {
              background: #aaa;
              cursor: not-allowed;
            }

            .add-cart {
              min-width: 150px;
              border: none;
              background: #2a54d1;
              color: #fff;
            }
          }
        }
      }

      .good_spu_detail {
        // overflow: hidden;
        max-width: 100%;

        /deep/ img {
          max-width: 100%;
        }

        .detail-item {
          .good-detail-title {
            height: 30px;
            border-bottom: 3px solid #468bd4;
            position: relative;
            margin-left: 16px;
            margin-bottom: 10px;

            &::before {
              content: " ";
              width: 12px;
              height: 30px;
              color: #468bd4;
              background: #468bd4;
              display: inline-block;
              position: absolute;
              left: -16px;
            }

            &::after {
              content: " ";
              width: 0;
              height: 0;
              display: inline-block;
              position: absolute;
              // left: 80px;
              border-bottom: 30px solid #468bd4;
              border-right: 30px solid transparent;
            }

            .name {
              float: left;
              background-color: #468bd4;
              color: #fff;
              font-weight: bold;
              font-size: 15px;
              height: 30px;
              line-height: 30px;
              padding: 0 10px;
              position: relative;
            }
          }
        }
      }

      .groupParams {
        border: 1px solid #eee;

        .model-params-name {
          padding: 12px 20px;
          font-size: 12px;
          line-height: 16px;
          color: #262727;
          font-weight: 500;
        }

        .attList {
          border-top: 1px solid #eee;
          display: flex;
          align-items: center;

          .att-name {
            padding: 10px;
            width: 30%;
            color: #999999;
            line-height: 16px;
            font-weight: 400;
            font-size: 12px;
            text-align: center;
            // flex-shrink: 1;
            // border-right: 1px solid #eee;
            flex-shrink: 0;
          }

          .att-value {
            // padding-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            line-height: 16px;
            padding: 10px;
            border-left: 1px solid #eee;
          }
        }
      }

      .attachment {
        color: #2e88ff;
        cursor: pointer;
      }
    }

    .match-model {
      margin-top: 40px;

      .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
        background: #f5f7fa;
        border: none;
        cursor: default;
      }
    }

    // 搭配型号
    .collocation {
      padding: 20px;
      display: flex;

      .collocation-good {
        width: 180px;
        text-align: center;

        img {
          border: none;
          border: 1px #eee dashed;
        }

        .collocation-good-name {
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: #333333;
          line-height: 24px;
        }
      }
    }
  }

  .good-services {
    display: flex;

    .service {
      margin-right: 10px;
      font-size: 10px;

      .icon-color {
        color: #2e88ff;
      }
    }
  }

  .promotion {
    margin-top: 10px;
    height: 36px;
    padding-left: 20px;
    line-height: 36px;
    background-image: linear-gradient(-30deg, #ff847e 0%, #e02a21 100%);
    display: -webkit-box;
    display: -ms-flexbox;
    justify-content: space-between;
    color: #fff;

    .promotion-title {
      .promotion-clock-img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }

      .promotion-count {
        padding: 3px 20px;
        margin-left: 20px;
        background: #cb2a22;
        border-radius: 10px;
      }
    }

    .promotion-time {
      display: flex;

      .promotion-content-arrow {
        width: 0;
        height: 0;
        border-top: 18px solid transparent;
        border-right: 36px solid #fadad8;
        border-bottom: 18px solid transparent;
      }

      .promotion-content {
        padding-right: 20px;
        text-align: right;
        color: #e02a21;
        background-color: #fadad8;

        // .no-bg{
        //   margin: 5px;
        // }
        /deep/.time-bg {
          text-align: center;
          background: #e02a21;
          color: #fff;
          padding: 5px;
          margin: 5px;
        }
      }
    }
  }

  .home_page {
    height: 100%;
  }
}
</style>
